import React from "react";
import { keyboardNavigation } from "../../../Util/Helper/keyboardNavigation";

const FocusableDiv = ({
  children,
  className,
  onBlur,
  onClick,
  onEscape,
  onEnter,
  style,
  tabIndex = 0,
  key,
  elementType: Element = "div",
}) => {
  return (
    <Element
      className={className}
      style={style}
      key={key}
      tabIndex={tabIndex}
      onClick={(e) => {
        if (onClick) onClick(e);
      }}
      onBlur={(e) => {
        if (onBlur) onBlur(e);
      }}
      onKeyDown={(e) => {
        keyboardNavigation(e, "Enter", () => {
          if (onEnter) {
            onEnter(e);
          } else {
            onClick && onClick(e);
          }
        });
        keyboardNavigation(e, "Escape", () => {
          if (onEscape) onEscape(e);
        });
      }}
    >
      {children}
    </Element>
  );
};

export default FocusableDiv;
